// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"141d864c","765":"34c4f165","778":"c72e0ae5","821":"0cec88ed","958":"d32996cd"}[chunkId] + ".chunk.js";
};